module.exports = __webpack_public_path__ + "img/404-background.5a5fbb84.png";